/**
 * 登录成功后的变化
 */

export const setUrlParam = (url, param, value) => {
  if (url.indexOf("?") != -1) {
    const p = new RegExp("(\\?|&" + param + ")=[^&]*");
    if (p.test(url)) {
      url = url.replace(p, "$1=" + value);
    } else {
      url = url + "&" + param + "=" + value;
    }
  } else {
    url = url + "?" + param + "=" + value;
  }
  return url;
};
